import { type Common } from '../common.js';
import {
  type CreateFlowBlockTemplateParams,
  type FindAllBlockTemplatesParams,
  type FlowBlockFavorite,
  type FlowBlockTemplate,
} from '../models/flow/flowTemplate.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/flow-templates';

  constructor(common: Common) {
    this.common = common;
  }

  async createBlockTemplate(
    params: CreateFlowBlockTemplateParams
  ): Promise<FlowBlockTemplate | undefined> {
    const { name, blockTemplate, description, organizationId } = params;
    const url = this.common.constructPath(`${this.baseEndpoint}/blocks`);
    return await this.common.postJSON(url, {
      name,
      blockTemplate,
      description,
      organizationId,
    });
  }

  async findAll(params?: FindAllBlockTemplatesParams): Promise<FlowBlockFavorite[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/blocks`, params);
    return await this.common.getJSON(url);
  }

  async findOneById(flowTemplateId: string): Promise<FlowBlockFavorite> {
    const url = this.common.constructPath(`${this.baseEndpoint}/blocks/${flowTemplateId}`);
    return await this.common.getJSON(url);
  }

  async delete(flowTemplateId: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/blocks/${flowTemplateId}`);
    return await this.common.deleteJSON(url);
  }
}
